// deno-lint-ignore-file ban-unused-ignore no-explicit-any no-empty-interface
///////////////////////////////////
// !!! DO NOT EDIT THIS FILE !!! //
///////////////////////////////////

import type { SlackAPIResponse } from "../response";
export type ChatPostEphemeralResponse = SlackAPIResponse & {
  error?: string;
  message_ts?: string;
  needed?: string;
  ok: boolean;
  provided?: string;
};
